import React from 'react';
import { Modal } from '@/features/modals/components';
import { IntercomAPI } from '@/integrations/Intercom';
import styled from 'styled-components';

export const MoreResultsExplainerModal: React.FC<{ rowCount: number }> = ({
  rowCount,
}) => (
  <Modal title={`We've returned ${rowCount} rows`} noDefaultFooter>
    <ContentContainer>
      <span>
        When you click the <b>load more</b> button, we return up to{' '}
        <b>1800 data points</b>.
      </span>
      <br />
      <span>
        That's the max number of data points you can display on a Trevor.io
        dashboard.
      </span>
      <br />
      <span>
        A <b>data point</b> is basically a cell in your results table.
      </span>
      <br />
      <span>
        We calculate the number of data points by{' '}
        <em>multipling the number of rows by the number of columns</em>.
      </span>
      <br />
      <span>
        <em>E.g. a table with 5 rows and 5 columns contains 25 data points.</em>
      </span>
      <br />
      <span>
        Have a question?{' '}
        <span className="link" onClick={IntercomAPI.show}>
          Chat with us
        </span>
        .
      </span>
    </ContentContainer>
  </Modal>
);

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  padding-block: var(--spacing-xl);
`;
